import {
  Checkbox,
  FormControlLabel,
  FormControlLabelProps,
  FormGroup,
  Tooltip,
} from '@mui/material'
import { EditOutlined } from '@mui/icons-material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { ProjectController } from 'controllers/Project/ProjectController'
import { useAppController } from 'customHooks/useAppController'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { ShowException } from 'store/Application/appActions'
import { useAppSelector } from 'store/configureStore'
import { useTranslation } from 'react-i18next'

export const ProjectStatusChangeInPortalAllowed = (
  props: Partial<FormControlLabelProps>
) => {
  const { t } = useTranslation('project')

  const statusChangeInPortalIsAllowed = useAppSelector(
    projectSelectors.projectStatusChangeInPortalAllowedSelector
  )
  const statusChangeInPortalIsAllowedManuallySet = useAppSelector(
    projectSelectors.projectStatusChangeInPortalAllowedManuallySetSelector
  )
  const isBuyerView = useAppSelector(
    projectSelectors.projectInBuyerViewSelector
  )

  const { controller, loading } = useAppController(
    () => new ProjectController()
  )

  if (isBuyerView) return null

  const handleChange = async (allowed: boolean) => {
    try {
      await controller.SetStatusChangeInPortalAllowed(allowed)
    } catch (err) {
      ShowException('project', err)
    }
  }

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checked={statusChangeInPortalIsAllowed ?? true}
            onChange={(_e, checked) => handleChange(checked)}
            size={'small'}
            sx={{
              padding: (theme) => theme.spacing(0, 0, 0, 0.5),
            }}
          />
        }
        label={
          <>
            <LocalizedTypography
              translationKey={'project:status-change-in-portal-is-allowed'}
              defaultValue={'status change allowed in portal'}
              variant="caption"
            />
            {statusChangeInPortalIsAllowedManuallySet && (
              <Tooltip
                title={t(
                  'status-change-in-portal-manually-set',
                  'manually set'
                )}
              >
                <EditOutlined
                  fontSize="inherit"
                  sx={{ ml: 0.5, verticalAlign: 'middle', opacity: 0.6 }}
                />
              </Tooltip>
            )}
          </>
        }
        labelPlacement="start"
        disabled={loading['SetStatusChangeInPortalAllowed']}
        {...props}
      />
    </FormGroup>
  )
}
